const requestInterceptorHandlers = [];
const responseInterceptorHandlers = [];
const errorHandlers = [];

export const registerRequestInterceptor = (interceptorHandler) => {
    requestInterceptorHandlers.push({
        interceptorHandler,
    });
};

export const registerResponseInterceptor = (interceptorHandler) => {
    responseInterceptorHandlers.push({
        interceptorHandler,
    });
};

export const registerErrorHandler = (errorHandler) => {
    if (errorHandler) {
        errorHandlers.push({
            errorHandler,
        });
    }
};

const removeHandler = (handlerList, handler, propName) => {
    if (handler) {
        const toRemoveIndex = handlerList.findIndex((item) => {
            return item[propName] === handler;
        });

        if (toRemoveIndex !== -1) {
            handlerList.splice(toRemoveIndex, 1);
        }
    }
};

export const unRegisterRequestInterceptor = (interceptorHandler) => {
    removeHandler(
        requestInterceptorHandlers,
        interceptorHandler,
        'interceptorHandler',
    );
};

export const unRegisterResponseInterceptor = (interceptorHandler) => {
    removeHandler(
        responseInterceptorHandlers,
        interceptorHandler,
        'interceptorHandler',
    );
};

export const unRegisterErrorHandler = (errorHandler) => {
    removeHandler(errorHandlers, errorHandler, 'errorHandler');
};

export const getRequestInterceptorHandlers = () => requestInterceptorHandlers;
export const getResponseInterceptorHandlers = () => responseInterceptorHandlers;
export const getErrorHandlers = () => errorHandlers;
